import { Instrument } from './Instrument';
export class Tablet extends Instrument {
    constructor(cameraParent) {
        super(cameraParent);
        this.hand = 'left';
        this.stickToHand = true;
        this.modelConfig = {
            modelPath: require('../../assets/instruments/tablet/tablet.fbx'),
            material: [{
                    materialName: 'tablet_mtl_s',
                    type: 'pbr',
                    texturePaths: {
                        baseColor: require('../../assets/instruments/tablet/textures/tablet_bc.jpg'),
                        orm: require('../../assets/instruments/tablet/textures/tablet_orm.png')
                    }
                }],
        };
    }
    prepareResources(loader) {
        super.prepareResources(loader);
        // this.model.scale.setScalar(0.01)
        this.model.rotateX(-0.7);
        // this.model.rotateZ(Math.PI / 4)
        this.model.position.set(0.17, -0.155, 0.13);
    }
}
